/**
 *
 * @param directory Path to the directory to require
 */
export function requireFilesFromDirectory(directory) {
  return directory.keys();
}
